import getPositionOfElement from '../util/getPositionOfElement';

(function () {
    /**
     * Scroll the document to a specific element with an offset.
     * @param {HTMLElement} element
     * @param {number} offset
     */
    const scrollToElement = (element, offset = 0) => {
        const { top } = getPositionOfElement(element);
        window.scrollTo({
            top: top - offset,
            left: 0,
            behavior: 'smooth',
        })
    }

    /**
     * Returns an object with an element and an offset.
     * @param {string} selector The query to find the element.
     * @returns {(object|null)}
     */
    const getElementAndOffset = selector => {
        let offset = 0;

        const target = document.querySelector(selector);
        if (target === null) {
            return null;
        }

        const header = document.querySelector('dynamic-banner.header-dynamic');

        if (header !== null) {
            offset = header.offsetHeight;
        }

        return {
            element: target,
            offset,
        };
    };

    /**
     * Check the clicked element if its an anchor that starts with a hash.
     * Then scroll to the targetted element with an offset.
     * @param {Event} event The click event object.
     * @returns {void}
     */
    const onClick = event => {
        const anchor = event.target.closest('a[href^="#"]');
        if (anchor === null) {
            return;
        }

        const target = getElementAndOffset(anchor.hash);

        if (target === null) {
            return;
        }

        const { element, offset } = target;

        scrollToElement(element, offset);
        event.preventDefault();
    };

    /**
     * Check if a hash exists.
     * If it does, find the element that belongs to it and scroll to the element.
     */
    const hash = window.location.hash;
    if (hash.length !== 0) {
        const target = getElementAndOffset(hash);
        if (target !== null) {
            const { element, offset } = target;
            scrollToElement(element, offset);
        }
    }

    document.addEventListener('click', onClick);
}());



// WEBPACK FOOTER //
// ./scripts/custom/scrollTo.js